import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '+127',
  label: 'Agentes',
  sub: 'Implementaron el Sistema A.C.E.™'
}, {
  value: '+843',
  label: 'Transacciones',
  sub: 'Generadas para nuestros clientes'
}, {
  value: '30-90',
  label: 'Días',
  sub: 'Para ver los primeros resultados'
}, {
  value: '100%',
  label: 'Exclusivo',
  sub: 'Leads solo para tu zona'
}];
export function StatsSection() {
  return <section className="py-12 md:py-16 px-5 md:px-8 bg-dark-200 relative" data-id="element-240">
      {/* Top Gold Accent Line */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gold/40 to-transparent" data-id="element-241" />

      <div className="max-w-7xl mx-auto" data-id="element-242">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-0 md:divide-x divide-gold/10" data-id="element-243">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center md:px-6" data-id="element-244">
              <div className="text-4xl md:text-5xl lg:text-6xl font-black text-gold leading-none mb-3" data-id="element-245">
                {stat.value}
              </div>
              <div className="text-white font-bold text-xs md:text-sm uppercase tracking-widest mb-2" data-id="element-246">
                {stat.label}
              </div>
              <div className="text-gray-500 text-xs md:text-sm leading-snug max-w-[200px] mx-auto" data-id="element-247">
                {stat.sub}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}